import { css } from '@emotion/css'
import { StatsContainer } from '../StatsContainer'
import { StatsHeader } from '../stats_header/StatsHeader'
import { MomBooksGrid } from './MomBooksGrid'
import { useStats } from '../../lib/ctx/stats'
import { getMonthlyBooksResult } from '../../lib/utils'
import { useStatsPermission, useStatsZeroState } from '../../lib/hooks'
import { ReaderInsight } from '../shared'
import { MomBooksShareButton } from './MomBooksShareButton'
import { MomBooksInsight } from './MomBooksInsight'
import { forwardRef, Ref } from 'react'
import { StatsHeaderTitle } from '../stats_header'

export const Content = (_: any, ref: Ref<HTMLDivElement>) => {
  const [stats, theme, yearStatus, year] = useStats((s) => [
    s.stats,
    s.theme,
    s.yearStatus,
    s.year,
  ])
  const { booksRead, booksReadUnit } = getMonthlyBooksResult(stats)
  const zeroState = useStatsZeroState('mom-books-read')
  const { isStatsOwner } = useStatsPermission()
  const isPastYear = yearStatus === 'past'

  const getContent = () => {
    if (zeroState && isStatsOwner) {
      if (yearStatus !== 'current') return null

      return (
        <ReaderInsight
          data-testid="reader-insight-mom-books"
          label="How to get started"
          text="Add books to your Finished list, and make sure to mark that you
        finished it this year."
          backgroundColor={theme.bg200}
        />
      )
    }

    return (
      <>
        {!zeroState ? <MomBooksGrid /> : null}
        {!isPastYear && isStatsOwner ? <MomBooksInsight /> : null}
      </>
    )
  }

  return (
    <StatsContainer
      id="monthly-books"
      ref={ref}
      data-testid="stats-mom-books"
      empty={zeroState}
    >
      <StatsHeader actions={zeroState ? null : <MomBooksShareButton />}>
        <StatsHeaderTitle
          top="Finished"
          middle="0"
          bottom={
            <>
              {booksReadUnit}
              <span
                className={css`
                  margin-left: 4px;
                  opacity: 0.5;
                `}
              >
                {isPastYear ? `in ${year}` : 'so far this year'}
              </span>
            </>
          }
          counter={!zeroState ? { to: booksRead } : undefined}
          infoButton={{
            text: (
              <>
                <b>Missing a book?</b>
                <br />
                Check your Finished list to verify the book has a {year}{' '}
                finished date.
                <br />
                <br />
                <b>Need to remove a book?</b>
                <br />
                Remove the book’s {year} finished date in your Finished list. If
                the book isn’t in your Finished list but is showing up in your{' '}
                {year} stats, re-add the book to your Finished list in order to
                remove its read date(s).
              </>
            ),
          }}
        />
      </StatsHeader>
      {getContent()}
    </StatsContainer>
  )
}

export const MomBooksStats = forwardRef(Content)
